import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import ErrorComponent from "../ErrorComponent";

const AuthenticatedErrorFallbackComponent = ({ error, componentStack, resetErrorBoundary }) => {
  return (
    <ErrorComponent
      error={error}
      componentStack={componentStack}
      resetErrorBoundary={resetErrorBoundary}
      isAuthenticated={true}
    />
  );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedErrorFallbackComponent);
